import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FaArrowLeftLong } from "react-icons/fa6";

import FormInput from "../../components/common/FormInput/FormInput";
import Button from "../../components/common/Button/Button";
import { showToast } from "../../components/common/ToastNotification/ToastNotification";
import Loader from "../../components/Loader/Loader";

import {
  getAttributeById,
  AttributeUpdate,
} from "../../api/service/attribute.service";

const UpdateAttribute = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);

  const [formData, setFormData] = useState({
    page_name: "",
    attribute: "",
    value: "",
  });

  useEffect(() => {
    const fetchAttribute = async () => {
      try {
        setFetching(true);
        const res = await getAttributeById(id);

        if (res?.data) {
          setFormData({
            page_name: res.data.page_name || "",
            attribute: res.data.attribute || "",
            value: res.data.value || "",
          });
        }
      } catch (error) {
        console.error(error);
        showToast.error("Failed to load attribute");
      } finally {
        setFetching(false);
      }
    };

    if (id) fetchAttribute();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.page_name || !formData.attribute || !formData.value) {
      showToast.error("All fields are required");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        attribute_id: id,
        page_name: formData.page_name,
        attribute: formData.attribute,
        value: formData.value,
      };

      const res = await AttributeUpdate(payload);

      if (res?.data?.success) {
        showToast.success(
          res?.data?.message || "Attribute updated successfully"
        );
        navigate("/attribute");
      } else {
        showToast.error(res?.data?.message || "Something went wrong");
      }
    } catch (error) {
      console.error(error);
      showToast.error(
        error?.response?.data?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  if (fetching) return <Loader />;

  return (
    <>
      <div className="d-flex align-items-center gap-2 mb-3">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        <h3 className="mb-0 management-tile ml-2">Update Attribute</h3>
      </div>

      <form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} className="mb-3">
            <label className="form-label">Page Name</label>
            <FormInput
              name="page_name"
              value={formData.page_name}
              onChange={handleChange}
              placeholder="Enter page name"
              disabled={loading}
            />
          </Col>

          <Col xs={12} className="mb-3">
            <label className="form-label">Attribute</label>
            <FormInput
              name="attribute"
              value={formData.attribute}
              onChange={handleChange}
              placeholder="Enter attribute"
              disabled={loading}
            />
          </Col>

          <Col xs={12} className="mb-3">
            <label className="form-label">Value</label>
            <FormInput
              name="value"
              value={formData.value}
              onChange={handleChange}
              placeholder="Enter value"
              disabled={loading}
            />
          </Col>

          <Col xs={12}>
            <Button type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update Attribute"}
            </Button>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default UpdateAttribute;
